import CountryEnum from '../constants/country-enum';

const useGetCountry = () => {
  // Extract the TLD from the hostname
  const topLevelDomain = window.location.hostname.split('.').pop();
  switch (topLevelDomain) {
    case 'cl':
      return CountryEnum.CHILE;
    case 'mx':
      return CountryEnum.MEXICO;
    default:
      return CountryEnum.CHILE;
  }
};

export default useGetCountry;
